import { node_observable_component } from 'common/util/ComponentDecorator';

@node_observable_component
export default class PhotoUpload {
	static classname = 'photo-upload';

	_error = '';
	_storage = {};

	constructor($context) {
		this.$context = $context;

		this.bindEvents();
		this.initSwiper();
	}

	get $storage() {
		return this.$context.find('.photo-upload__storage');
	}

	get $upload_photos() {
		return this.$context.find('.photo-upload__upload-photos');
	}

	get is_disabled_box() {
		return this.$context.hasClass('photo-upload_disabled-box');
	}

	set is_disabled_box(is_disabled_box) {
		this.$context.toggleClass('photo-upload_disabled-box', is_disabled_box);
		this.$context.find('.photo-upload__control').prop('disabled', is_disabled_box);
	}

	get namespace() {
		return this.$context.data('namespace');
	}

	get max_count() {
		return this.$context.data('max-count');
	}

	get types() {
		const types = this.$context.data('types');
		if (!(types instanceof Array)) {
			return [];
		}

		return types;
	}

	get mime_types() {
		const mime_types = this.types.map(type => {
			if (type === 'png') {
				return 'image/png';
			} else if (type === 'jpg') {
				return 'image/jpeg';
			} else if (type === 'gif') {
				return 'image/gif';
			}
		});

		return mime_types;
	}

	get max_post_size() {
		return this.$context.data('max-post-size');
	}

	get max_file_size() {
		return this.$context.data('max-file-size');
	}

	get storage() {
		return this._storage;
	}

	set storage(storage) {
		this._storage = storage;

		this.handleChangeStorage();

		if (this.count >= this.max_count) {
			this.is_disabled_box = true;
		}
	}

	get count() {
		return Object.keys(this.storage).length;
	}

	get last_index() {
		const keys = Object.keys(this.storage);
		if (!keys.length) {
			return -1;
		}

		return keys[keys.length - 1];
	}

	get auto_increment_index() {
		let index = +this.last_index + 1;
		while (this.storage.hasOwnProperty(index)) {
			index++;
		}

		return index;
	}

	get error() {
		return this._error;
	}

	set error(error) {
		if (this.error_hide_timeout) {
			clearInterval(this.error_hide_timeout);
		}

		this._error = error;
		this.$context.find('.photo-upload__error').html(error);

		const has_error = this._error !== '';
		this.$context.toggleClass('photo-upload_error', has_error);

		if (has_error) {
			this.error_hide_timeout = setTimeout(() => {
				this.error = '';
			}, 2000);
		}
	}

	getFileNameAttr(index) {
		return `${this.namespace}[${index}]`;
	}

	bindEvents() {
		this.$context.on('change', '.photo-upload__control', this.handleChangeControl);

		this.$upload_photos.on('click', '.photo-upload__upload-photo-action_delete', this.handleClickDeleteUploadPhoto);
	}

	initSwiper() {
		this.swiper = new Swiper(this.$context.find('.photo-upload__upload-area')[0], {
			wrapperClass: 'photo-upload__upload-photos',
			slideClass: 'photo-upload__upload-photo',
			spaceBetween: 0,
			slidesPerView: 'auto',
			observer: true
		});
	}

	/**
	 * @param {HTMLInputElement} target
	 * @param {File} file
	 */
	store(target, file) {
		const index = this.auto_increment_index;

		this.storage = {
			...this.storage,
			[index]: {
				target,
				file
			}
		};
	}

	delete(index) {
		if (!this.storage.hasOwnProperty(index)) {
			return;
		}

		delete this.storage[index];
		this.storage = this.storage;
	}

	/**
	 * @param {File} file
	 * @return {boolean}
	 */
	isCorrectType(file) {
		return this.mime_types.some(type => file.type === type);
	}

	/**
	 * @param {File} file
	 * @return {boolean}
	 */
	isAlreadyUpload(file) {
		return Object.values(this.storage).some(({file: _file}) =>
			file.name === _file.name
			&& file.type === _file.type
			&& file.size === _file.size
		);
	}

	build$UploadPhoto = (file, index) => {
		const $upload_photo = this.$upload_photos.find('.photo-upload__upload-photo_example').clone();
		$upload_photo.attr('data-index', index);
		$upload_photo.data('index', index);

		const $image = $upload_photo.find('.photo-upload__upload-photo-image');
		const reader = new FileReader();
		reader.onload = e => {
			$image.attr('src', e.target.result);
			$upload_photo.removeClass('photo-upload__upload-photo_example');
		};
		reader.readAsDataURL(file);

		const $name = $upload_photo.find('.photo-upload__upload-photo-name');
		$name.html(file.name);

		return $upload_photo;
	};

	handleChangeControl = e => {
		this.error = '';

		/**
		 * @var {FileList|null} files
		 */
		const files = e.target.files;

		if (!files || files.length === 0) {
			return;
		}

		const file = files[0];

		let error = null;
		if (!this.isCorrectType(file)) {
			error = `Разрешено загружать только изображения форматов ${this.types.join(', ')}`;
		}

		if (this.isAlreadyUpload(file)) {
			error = 'Это изображение уже загружено';
		}

		if (error) {
			this.error = error;
			e.target.value = '';
			return;
		}

		this.store(e.target, file);
	};

	handleChangeStorage() {
		const self = this;

		Object.entries(this.storage).forEach(([index, { target, file }]) => {
			let $item = this.$storage.find(`[data-index="${index}"]`);
			if (!$item.length) {
				const name_attr = this.getFileNameAttr(index);
				const $target = $(target);
				$item = $target.clone();
				$target.val('');
				$item.attr('name', name_attr);
				$item.attr('class', '');
				$item.attr('data-index', index);
				$item.data('index', index);
				$item.prependTo(this.$storage);
			}

			let $upload_photo = this.$upload_photos.find(`.photo-upload__upload-photo[data-index="${index}"]`);
			if (!$upload_photo.length) {
				$upload_photo = this.build$UploadPhoto(file, index);
				$upload_photo.prependTo(this.$upload_photos);
			}
		});

		this.$storage.find(':file').each(function () {
			const index = $(this).data('index');
			if (!self.storage.hasOwnProperty(index)) {
				$(this).remove();
			}
		});

		this.$upload_photos.find('.photo-upload__upload-photo:not(.photo-upload__upload-photo_example)').each(function () {
			const index = $(this).data('index');
			if (!self.storage.hasOwnProperty(index)) {
				$(this).remove();
			}
		});
	}

	handleClickDeleteUploadPhoto = e => {
		const $target = $(e.currentTarget);
		const $upload_photo = $target.closest('.photo-upload__upload-photo');
		const index = +$upload_photo.data('index');

		this.delete(index);
	};
}
